// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles_summary__GpRXN","address":"styles_address__0zPI6","value":"styles_value__QZGDS","method":"styles_method__T67W4","wrapper":"styles_wrapper__pHP6q"};